window.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".c-about-us").forEach(item => {
    window.addEventListener("keydown", e => {
      if (e.key === "Escape") {
        item.querySelectorAll("[data-toggles]").forEach(e => e.classList.remove("active"));
        item.querySelectorAll("[data-toggled-by]").forEach(e => e.classList.remove("active"));
      }
    }, {
      passive: true
    });
    item.querySelectorAll("[data-href]").forEach(href => {
      href.addEventListener("click", () => {
        if (href.dataset.hrefTarget === "_blank") window.open(href.dataset.href);else window.location.href = href.dataset.href;
      });
    });
    item.querySelectorAll("[data-toggles]").forEach(toggle => {
      toggle.addEventListener("click", () => {
        const disable = toggle.dataset.toggles.substring(0, 1) === "!";
        const target = disable ? toggle.dataset.toggles.substring(1) : toggle.dataset.toggles;
        item.querySelectorAll("[data-toggles]").forEach(e => e.classList.remove("active"));
        item.querySelectorAll("[data-toggled-by]").forEach(e => e.classList.remove("active"));
        if (!disable) {
          item.querySelectorAll(`[data-toggles="${target}"],[data-toggles="!${target}"]`).forEach(e => e.classList.add("active"));
          item.querySelectorAll(`[data-toggled-by="${target}"],[data-toggled-by="!${target}"],[data-toggled-by="!"]`).forEach(e => e.classList.add("active"));
        }
      });
    });
  });
});